import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Stack, Typography } from "@mui/material";

const TeamMemberAutocompleteTag = ({
  name,
  onDelete,
  ...tagProps
}: {
  name: string;
  onDelete: (event: React.MouseEvent) => void;
}) => (
  <Stack
    {...tagProps}
    direction="row"
    sx={{
      bgcolor: "shades.ghost.500",
      borderRadius: "8px",
      p: "4px 8px",
      "&:not(:first-of-type)": {
        ml: 0.5,
      },
    }}
    alignItems="center"
  >
    <Typography variant="bodyPrimaryReg" sx={{ color: "shades.neutral.800" }}>
      {name}
    </Typography>
    <IconButton
      onClick={onDelete}
      sx={{ height: "20px", width: "20px", ml: 1 }}
    >
      <CloseIcon sx={{ height: "14px", width: "14px" }} />
    </IconButton>
  </Stack>
);

export default TeamMemberAutocompleteTag;
